import React from "react"

const Footer = () => {
  return (
    <footer className='footer py-3'>
      <div className="container">
        <div className="row">
          <div className="col-10 mx-auto col-md-6 text-orange text-center text-capitalize">
            <small><a className='custom-footer' target="_blank" href="https://www.nolanjames.me/">Nolan James
              - {new Date().getFullYear().toString()}</a></small>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
